document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initBuscadorHero();
});

function initRevelado() {
  var elementos = document.querySelectorAll('.mt-reveal');
  if (!elementos.length) return;

  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          var retraso = entrada.target.dataset.mtRetraso || 0;
          setTimeout(function () {
            entrada.target.classList.add('mt-visible');
          }, Number(retraso));
          observer.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  elementos.forEach(function (el, indice) {
    if (!el.dataset.mtRetraso) {
      el.dataset.mtRetraso = String(Math.min(indice % 4, 3) * 90);
    }
    observer.observe(el);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
    var principal = galeria.querySelector('[data-mt-imagen-principal]');
    var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        var nuevaUrl = miniatura.getAttribute('data-mt-miniatura');
        if (!nuevaUrl) return;
        principal.src = nuevaUrl;
        miniaturas.forEach(function (m) { m.classList.remove('mt-activa'); });
        miniatura.classList.add('mt-activa');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-mt-producto-form]').forEach(function (formWrap) {
    var datosScript = formWrap.querySelector('[data-mt-variantes-json]');
    if (!datosScript) return;

    var variantes;
    try {
      variantes = JSON.parse(datosScript.textContent);
    } catch (e) {
      return;
    }

    var inputId = formWrap.querySelector('[data-mt-variant-id]');
    var precioEl = formWrap.querySelector('[data-mt-precio]');
    var precioTachadoEl = formWrap.querySelector('[data-mt-precio-tachado]');
    var botonComprar = formWrap.querySelector('[data-mt-boton-comprar]');
    var pastillasGrupos = formWrap.querySelectorAll('[data-mt-opcion-grupo]');
    var imagenPrincipal = document.querySelector('[data-mt-imagen-principal]');
    var miniaturas = document.querySelectorAll('[data-mt-miniatura]');

    function formatearPrecio(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      });
    }

    function opcionesSeleccionadas() {
      var seleccion = [];
      pastillasGrupos.forEach(function (grupo) {
        var activa = grupo.querySelector('.mt-activa');
        seleccion.push(activa ? activa.getAttribute('data-mt-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (variante) {
        return variante.options.every(function (valor, indice) {
          return valor === seleccion[indice];
        });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) {
        if (botonComprar) {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-no-disponible') || 'No disponible';
        }
        return;
      }

      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatearPrecio(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = formatearPrecio(variante.compare_at_price);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (variante.image && imagenPrincipal) {
        imagenPrincipal.src = variante.image;
        miniaturas.forEach(function (m) {
          var esLaMisma = m.getAttribute('data-mt-miniatura') === variante.image;
          m.classList.toggle('mt-activa', esLaMisma);
        });
      }
      if (botonComprar) {
        if (variante.available) {
          botonComprar.disabled = false;
          botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-comprar') || 'Añadir al carrito';
        } else {
          botonComprar.disabled = true;
          botonComprar.textContent = botonComprar.getAttribute('data-mt-texto-agotado') || 'Agotado';
        }
      }
    }

    pastillasGrupos.forEach(function (grupo) {
      grupo.querySelectorAll('[data-mt-valor]').forEach(function (pastilla) {
        pastilla.addEventListener('click', function () {
          if (pastilla.disabled) return;
          grupo.querySelectorAll('[data-mt-valor]').forEach(function (p) { p.classList.remove('mt-activa'); });
          pastilla.classList.add('mt-activa');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

function initCantidadProducto() {
  document.querySelectorAll('[data-mt-cantidad]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var menos = wrap.querySelector('[data-mt-menos]');
    var mas = wrap.querySelector('[data-mt-mas]');
    if (!input) return;

    if (menos) {
      menos.addEventListener('click', function () {
        var valor = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = valor;
      });
    }
    if (mas) {
      mas.addEventListener('click', function () {
        var valor = (parseInt(input.value, 10) || 1) + 1;
        input.value = valor;
      });
    }
  });
}

function initBuscadorHero() {
  document.querySelectorAll('[data-mt-buscador-hero]').forEach(function (form) {
    form.addEventListener('submit', function (evento) {
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) {
        evento.preventDefault();
      }
    });
  });
}
